export var VERSION = '1.17.1';
//# sourceMappingURL=version.js.map